module.exports = __webpack_public_path__ + "img/pup29.0b048a53.jpg";